import React from 'react';
import SEOHead from '../../components/SEO/SEOHead';
import { FileText, Mail, Phone, Building } from 'lucide-react';

const Service: React.FC = () => {
  return (
    <>
      <SEOHead
        title="서비스 이용약관 - Sparrow"
        description="Sparrow 100일 개인성장 챌린지의 서비스 이용약관입니다. 서비스 이용 전 반드시 확인해주세요."
        url="https://sparrow100.pages.dev/service"
      />
      <div className="min-h-screen bg-gradient-to-br from-sparrow-50 via-white to-sparrow-50">
        <div className="max-w-4xl mx-auto px-4 py-8 sm:py-12">
          <div className="card-elevated p-6 sm:p-8 space-y-8">
            {/* 헤더 */}
            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <div className="p-3 bg-sparrow-100 rounded-full">
                  <FileText className="w-8 h-8 text-sparrow-600" />
                </div>
              </div>
              <h1 className="text-3xl sm:text-4xl font-bold text-sparrow-800">
                서비스 이용약관
              </h1>
              <p className="text-neutral-600">
                최종 수정일: 2024년 12월 18일
              </p>
            </div>

            {/* 회사 정보 */}
            <div className="bg-sparrow-50 rounded-xl p-6 space-y-4">
              <h2 className="text-xl font-bold text-sparrow-800 flex items-center gap-2">
                <Building className="w-5 h-5" />
                회사 정보
              </h2>
              <div className="space-y-2 text-neutral-700">
                <p><strong>회사명:</strong> GOLDSAJU</p>
                <p className="flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  <strong>이메일:</strong> contact@goldsaju.com
                </p>
                <p className="flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  <strong>연락처:</strong> +82 010-2719-4855
                </p>
              </div>
            </div>

            {/* 본문 */}
            <div className="space-y-6 text-neutral-700 leading-relaxed">
              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제1조 (목적)</h2>
                <p>
                  이 약관은 GOLDSAJU(이하 "회사")가 제공하는 Sparrow 100일 개인성장 챌린지 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제2조 (정의)</h2>
                <p className="mb-4">이 약관에서 사용하는 용어의 정의는 다음과 같습니다:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>"서비스"</strong>란 회사가 제공하는 100일 개인성장 챌린지 플랫폼 및 관련 제반 서비스를 의미합니다.</li>
                  <li><strong>"이용자"</strong>란 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.</li>
                  <li><strong>"회원"</strong>이란 회사에 개인정보를 제공하여 회원등록을 한 자로서, 회사의 정보를 지속적으로 제공받으며, 회사가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.</li>
                  <li><strong>"비회원"</strong>이란 회원에 가입하지 않고 회사가 제공하는 서비스를 이용하는 자를 말합니다.</li>
                  <li><strong>"콘텐츠"</strong>란 서비스를 통해 제공되는 정보, 텍스트, 그래픽, 링크 등을 의미합니다.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제3조 (약관의 게시와 개정)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>회사는 이 약관의 내용을 이용자가 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다.</li>
                  <li>회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.</li>
                  <li>회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 서비스의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.</li>
                  <li>이용자는 개정된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 회원 탈퇴를 요청할 수 있습니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제4조 (서비스의 제공 및 변경)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>회사는 다음과 같은 서비스를 제공합니다:
                    <ul className="list-disc list-inside space-y-1 ml-6 mt-2">
                      <li>100일 개인성장 챌린지 진행 관리</li>
                      <li>일일 활동 기록 및 통계 제공</li>
                      <li>보상 시스템 운영</li>
                      <li>기타 회사가 추가 개발하거나 제휴계약 등을 통해 제공하는 일체의 서비스</li>
                    </ul>
                  </li>
                  <li>회사는 서비스의 내용을 변경할 수 있으며, 변경 시에는 사전에 공지합니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제5조 (서비스의 중단)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</li>
                  <li>회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</li>
                  <li>사업종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 회사는 제8조에 정한 방법으로 이용자에게 통지합니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제6조 (회원가입)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.</li>
                  <li>회사는 제1항과 같이 회원가입을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다:
                    <ul className="list-disc list-inside space-y-1 ml-6 mt-2">
                      <li>가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우</li>
                      <li>등록 내용에 허위, 기재누락, 오기가 있는 경우</li>
                      <li>기타 회원으로 등록하는 것이 회사의 기술상 현저히 지장이 있다고 판단되는 경우</li>
                    </ul>
                  </li>
                  <li>회원가입계약의 성립 시기는 회사의 승낙이 회원에게 도달한 시점으로 합니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제7조 (회원정보의 변경)</h2>
                <p>
                  회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디 등은 수정이 불가능합니다.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제8조 (개인정보보호)</h2>
                <p>
                  회사는 이용자의 개인정보 수집 시 서비스 제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다. 회사는 회원가입 시 구매계약이행에 필요한 정보를 미리 수집하지 않습니다. 회사의 개인정보 처리에 대해서는 관련법령 및 회사가 수립하여 공개한 개인정보처리방침을 적용합니다.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제9조 (이용자의 의무)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>이용자는 다음 행위를 하여서는 안 됩니다:
                    <ul className="list-disc list-inside space-y-1 ml-6 mt-2">
                      <li>신청 또는 변경 시 허위내용의 등록</li>
                      <li>타인의 정보 도용</li>
                      <li>회사가 게시한 정보의 변경</li>
                      <li>회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
                      <li>회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
                      <li>회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                      <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위</li>
                    </ul>
                  </li>
                  <li>이용자는 관계법령, 이 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제10조 (회원의 ID 및 비밀번호에 대한 의무)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>회원은 Google OAuth를 통한 인증을 사용하며, 회원의 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.</li>
                  <li>회원은 제3자에게 자신의 계정을 양도, 대여, 담보제공 등의 처분행위를 할 수 없습니다.</li>
                  <li>회원은 자신의 계정이 부정하게 사용된 것을 인지한 경우 즉시 회사에 통보하여야 하며, 통보를 하지 않아 발생한 모든 손해는 회원의 책임으로 합니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제11조 (회사의 의무)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>회사는 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 지속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여야 합니다.</li>
                  <li>회사는 이용자가 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함) 보호를 위해 보안시스템을 구축하며 개인정보처리방침을 공시하고 준수합니다.</li>
                  <li>회사는 서비스와 관련하여 이용자로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 합니다. 이용자가 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 그 처리과정 및 결과를 전달합니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제12조 (보상 및 기부 시스템)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>회사는 이용자가 100일 챌린지를 완료하거나 일일 목표를 달성할 경우 보상을 제공할 수 있습니다.</li>
                  <li>보상은 현금, 포인트, 기부 등 다양한 형태로 제공될 수 있으며, 구체적인 내용은 서비스 내 공지사항을 통해 안내됩니다.</li>
                  <li>이용자는 보상을 직접 수령하거나 지정된 기부처에 기부할 수 있습니다.</li>
                  <li>보상 지급 및 기부 처리에 대한 책임은 회사에 있으며, 관련 세무 처리 등은 관련 법령에 따라 처리됩니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제13조 (손해배상)</h2>
                <p>
                  회사는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 동 손해가 회사의 중대한 과실에 의한 경우를 제외하고는 이에 대하여 책임을 부담하지 아니합니다.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제14조 (면책조항)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</li>
                  <li>회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</li>
                  <li>회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">제15조 (분쟁의 해결)</h2>
                <ol className="list-decimal list-inside space-y-2 ml-4">
                  <li>회사와 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를 관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는 민사소송법상의 관할법원에 제기합니다.</li>
                  <li>회사와 이용자 간에 제기된 전자상거래 소송에는 한국법을 적용합니다.</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-sparrow-800 mb-4">부칙</h2>
                <p>
                  이 약관은 2024년 12월 18일부터 시행됩니다.
                </p>
              </section>
            </div>

            {/* 문의 */}
            <div className="border-t border-neutral-200 pt-6 mt-8">
              <p className="text-center text-neutral-600">
                서비스 이용약관에 대한 문의사항이 있으시면 언제든지 연락주시기 바랍니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Service;
